import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

const AUTH_API = environment.url;

@Injectable({
    providedIn: 'root',
})
export class SecHandService {
    constructor(private http: HttpClient) { }

    async get2Hands(dateI: any, dateF: any) {
        let data = await this.http
            .get<any>(
                AUTH_API +
                '2hand/product/child/all' // inicial phase without dates
            )
            .toPromise();
        return data;
    }

    async get2HandLines(product_child_id: any) {
        let data = await this.http
            .get<any>(AUTH_API + '2hand/product/child?id=' + product_child_id)
            .toPromise();
        return data;
    }

    async get2HandJournal(product_child_id: any) {
        try {
            let data = await this.http
                .get<any>(AUTH_API + '2hand/product/getHistoryJournal2hand?id=' + product_child_id)
                .toPromise();
            return data;
        }
        catch (error) {
            return [];
        }
    }

    async put2HandLinesStatus(lines: any) {
        console.log(lines)
        let data = await this.http.put<any>(AUTH_API + '2hand/product/child/status', lines).toPromise();
        return data;
    }

    async reject2hand(lines: any) {
        let data = await this.http.put<any>(AUTH_API + '2hand/product/child/status', lines).toPromise();
        return data;
    }

    async get2HandDashboardData(id_brand: number) {
        const data = await this.http.get<any>(AUTH_API + 'dashBoard/all2hand').toPromise();
        return data;
    }
    
    async get2HandDashboardRegisteredCustomers(dateI: any, dateF: any) {

        try {
            const headers = {
                'dateI': dateI,
                'dateF': dateF,
            };
            const data = await this.http.get<any>(AUTH_API + 'dashBoard/2handRegisteredCustomers', { headers }).toPromise();
            return data;
        } catch (error) {
            console.log(error)
            return null;
        }


    }
    async get2HandDashboardCurrentListings(dateI: any, dateF: any) {
        try {
            const headers = {
                'dateI': dateI,
                'dateF': dateF,
            };
            const data = await this.http.get<any>(AUTH_API + 'dashBoard/2handCurrentListings', { headers }).toPromise();
            return data;
        }
        catch (error) {
            console.log(error)
            return null;
        }
    }
    async get2HandDashboardNumberSales(dateI: any, dateF: any) {

        try {
            const headers = {
                'dateI': dateI,
                'dateF': dateF,
            };
            const data = await this.http.get<any>(AUTH_API + 'dashBoard/2handNumberSales', { headers }).toPromise();
            return data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
    async get2HandDashboardTotalSales(dateI: any, dateF: any) {
        try {
            const headers = {
                'dateI': dateI,
                'dateF': dateF,
            };
            const data = await this.http.get<any>(AUTH_API + 'dashBoard/2handTotalSales', { headers }).toPromise();
            return data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
    async get2HandDashboardTopListedProducts(dateI: any, dateF: any) {
        try {
            const headers = {
                'dateI': dateI,
                'dateF': dateF,
            };
            const data = await this.http.get<any>(AUTH_API + 'dashBoard/2handTopListedProducts', { headers }).toPromise();
            return data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
    async get2HandDashboardTopBestSellingProducts(dateI: any, dateF: any) {
        try {
            const headers = {
                'dateI': dateI,
                'dateF': dateF,
            };
            const data = await this.http.get<any>(AUTH_API + 'dashBoard/2handTopBestSellingProducts', { headers }).toPromise();
            return data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
    async get2HandDashboardSalesByCountry(dateI: any, dateF: any) {
        try {
            const headers = {
                'dateI': dateI,
                'dateF': dateF,
            };
            const data = await this.http.get<any>(AUTH_API + 'dashBoard/2handSalesByCountry', { headers }).toPromise();
            return data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
    async get2HandDashboardAverageSellingTime(dateI: any, dateF: any) {
        try {
            const headers = {
                'dateI': dateI,
                'dateF': dateF,
            };
            const data = await this.http.get<any>(AUTH_API + 'dashBoard/2handAverageSellingTime', { headers }).toPromise();
            return data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
    async get2HandDashboardPBelowRetailPrice(dateI: any, dateF: any) {
        try {
            const headers = {
                'dateI': dateI,
                'dateF': dateF,
            };
            const data = await this.http.get<any>(AUTH_API + 'dashBoard/2handPBelowRetailPrice', { headers }).toPromise();
            return data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async getLinkProductOnlineStore(subID:any){
        const data = await this.http.get<any>(AUTH_API + '2hand/product/getLinkStore?id_order='+ subID).toPromise();
        return data;
    }

    async putCloudinaryImage(imageData:any){
        let data = await this.http.put<any>(AUTH_API + '2hand/product/cloudinary/update', imageData).toPromise();
        return data;

    }

    
}
